import { IMRBaseComponent } from "../../base"

import { IMRSelectGridPopupController } from "./select-grid.popup.controller"

//#region Assets Imports

import './select-grid.popup.scss'
import * as TEMPLATE from './select-grid.popup.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrSelectGridPopup'

export class IMRSelectGridPopupComponent extends IMRBaseComponent {

    //#region Ctor

    public constructor() {
        super({
            controller: IMRSelectGridPopupController,
            template: TEMPLATE
        })
    }

    //#endregion
}

